import React, { Component } from 'react'
import { Row, Col, Button, Label, FormGroup, Input } from 'reactstrap'
import Dropzone from 'react-dropzone'
import { FileIcon } from 'react-file-icon'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import filesize from 'filesize'
import TruncateString from 'react-truncate-string'
import AsyncSelect from '../Input/AsyncSelect'
import oikosApi from '../../../services/oikos'

export default class AddContractFiles extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: [],
    }
  }

  componentWillUnmount() {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.state.files?.length > 0) {
      this.state.files.forEach(file => URL.revokeObjectURL(file.props.preview))
    }
    return null
  }

  handleOnDropFiles = (newAcceptedFiles) => {
    const { files } = this.state

    const acceptedFormatted = newAcceptedFiles?.map(file => {
      const icon = this.formatFileIcon(file.type)
      const extension = this.extractFileExtension(file.path)
      const name = (file.path).replace(/\.[^/.]+$/, '')

      return ({
        data: file,
        props: {
          id: uuidv4(),
          preview: URL.createObjectURL(file),
          modified: moment().format('DD/MM/YYYY HH:mm'),
          icon,
          extension,
          name,
          documentType: null,
          description: null,
        },
      })
    })

    this.setState({ files: files.concat(acceptedFormatted) })
  }

  formatFileIcon = type => {
    switch (type) {
      case 'application/pdf': return {
        color: '#ffcfcc',
        labelColor: '#FF2116',
        type: 'acrobat',
      }
      case 'image/png':
      case 'image/jpeg':
      case 'image/gif':
        return {
          color: '#ffe6cc',
          labelColor: '#ff9933',
          type: 'image',
        }
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return {
        color: '#d7f4e4',
        labelColor: '#207245',
        type: 'spreadsheet',
      }
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return {
        color: '#d7e3f4',
        labelColor: '#2a5699',
        type: 'document',
      }
      default: return {}
    }
  }

  extractFileExtension = path => {
    const fileExtensionPattern = /\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi

    return path.match(fileExtensionPattern)[0].substring(1)
  }

  handleDeleteFile = id => {
    const { files } = this.state

    const filtered = files.filter(file => file.props.id !== id)

    this.setState({ files: filtered })
  }

  render() {
    const { files } = this.state

    return (
      <>
        {files?.length > 0 && (
          <>
            {files.map((file, index) => (
              <div key={file.props.id}>
                <Row className="d-flex no-gutters align-items-start justify-content-between">
                  <div className="mr-3" style={{ width: 36, height: 43 }}>
                    <FileIcon
                      radius={4}
                      extension={file.props.extension}
                      type={file.props.icon.type}
                      color={file.props.icon.color}
                      labelColor={file.props.icon.labelColor}
                    />
                  </div>

                  <div className="d-flex flex-column flex-grow-1 mr-3" style={{ width: 1 }}>
                    <h6>
                      <TruncateString
                        text={file.data.path}
                      />
                    </h6>

                    <span>
                      {filesize(file.data.size, { locale: 'pt-BR', round: 0 })}
                    </span>

                    <Row className="mt-3">
                      <Col>
                        <FormGroup>
                          <Label>
                            Tipo de documento
                          </Label>

                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            isSearchable={false}
                            isClearable={false}
                            isMulti={false}
                            getOptionValue={option => option.tpDocumento_id}
                            getOptionLabel={option => option.tpDocumento_desc}
                            value={file.props.documentType}
                            loadOptions={async () => {
                              try {
                                const res = await oikosApi.get('/', {
                                  action: 'get',
                                  table: 'tpDocumento',
                                })

                                if (file.props.documentType !== null) {
                                  files[index].props.documentType = res.data.find(i => i.tpDocumento_id === file.props.tpDocumento_id)
                                  this.setState({ files })
                                }

                                return res.data.filter(i => i.tpDocumento_desc !== 'RG'
                                  && i.tpDocumento_desc !== 'CPF'
                                  && i.tpDocumento_desc !== 'CTPS'
                                  && i.tpDocumento_desc !== 'Contrato de Cliente'
                                  && i.tpDocumento_desc !== 'Minuta de Contrato')
                              } catch (e) {
                                return console.tron.log(e)
                              }
                            }}
                            onChange={e => {
                              files[index].props.documentType = e || null
                              this.setState({ files })
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          <Label>
                            Descrição
                          </Label>

                          <Input
                            value={file.props.description}
                            onChange={e => {
                              files[index].props.description = e?.target?.value || null
                              this.setState({ files })
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                  </div>

                  <div className="d-flex justify-content-end">
                    <Button
                      color="light"
                      size="sm"
                      title="Excluir"
                      onClick={() => this.handleDeleteFile(file.props.id)}
                    >
                      <i className="ri-delete-bin-6-line font-size-16" />
                    </Button>
                  </div>
                </Row>

                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
              </div>
            ))}
          </>
        )}

        <Row>
          <Col>
            <Dropzone
              maxSize={100000000}
              onDrop={(files) => this.handleOnDropFiles(files)}
            >
              {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject, isFocused }) => {
                const style = {
                  ...baseStyle,
                  ...(isDragActive ? activeStyle : {}),
                  ...(isDragAccept ? acceptStyle : {}),
                  ...(isDragReject ? rejectStyle : {}),
                  ...(isFocused ? focusStyle : {}),
                }

                return (
                  <div {...getRootProps({ style })} className="files-dropzone">
                    <input {...getInputProps()} />
                    <Row>
                      <Col>
                        <i
                          className="ri-upload-cloud-2-line mb-3"
                          style={{
                            fontSize: 42,
                            color: '#4aa3ff',
                            opacity: 0.8,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <h6>
                          Arraste e solte ou clique para buscar
                        </h6>
                      </Col>
                    </Row>
                  </div>
                )
              }}
            </Dropzone>
          </Col>
        </Row>
      </>
    )
  }
}

const baseStyle = {
  cursor: 'pointer',
  padding: '15px 16px 22px 16px',
  borderWidth: 2,
  borderRadius: 6,
  borderColor: '#ccc',
  borderStyle: 'dashed',
  backgroundColor: '#f8f8f8',
  outline: 'none',
  transition: 'all .24s ease-in-out',
  textAlign: 'center',
}

const activeStyle = {
  borderColor: '#4aa3ff',
  color: '#4aa3ff',
}

const focusStyle = {}

const acceptStyle = {
  borderColor: 'green',
  color: 'green',
}

const rejectStyle = {
  borderColor: 'red',
  color: 'red',
}
